import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const SigninLink = styled.a(() =>
  mq({
    display: 'inline-block',
    backgroundColor: defaultTheme.background.yellow,
    borderRadius: '24px',
    padding: [
      defaultTheme.spacing.m,
      defaultTheme.spacing.m,
      defaultTheme.spacing.l,
    ],
    marginLeft: [0, 0, 0, defaultTheme.spacing.l],
    minWidth: ['128px', '128px', '192px'],
    fontSize: defaultTheme.font.size.s,
    fontWeight: 'bold',
    lineHeight: defaultTheme.font.height.base,
    textAlign: 'center',
    color: defaultTheme.text.default,
    ...hoverOpacity,
  }),
);

export const RegisterLink = SigninLink.withComponent(Link);
